var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 140,
    viewBox: "0 0 184 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.216 40.6896L107.123 57.5193L92.0273 49.5802L76.8752 57.5193L77.8253 51.9286L79.7822 40.6896L67.5371 28.7798L84.4229 26.3195L92.0273 11L99.5758 26.3195L108.634 27.6632L116.461 28.7798L104.216 40.6896Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3555 28.6935L84.1481 27.3127C84.725 27.245 85.2255 26.882 85.4677 26.3539L89.8763 16.7539L86.5255 27.0624C86.2149 28.0169 85.3266 28.6644 84.3227 28.6666L72.3555 28.6935Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.217 40.6893L107.125 57.519L92.0291 49.5799L76.877 57.519L77.8271 51.9275C93.762 46.5601 104.05 34.2597 108.635 27.6621L116.462 28.7788L104.217 40.6893Z",
    fill: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3401_15140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 0,
    width: 28,
    height: 61
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61V0H64V61H92Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3401_15140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.179 40.5219L107.086 57.4907L91.9902 49.486L76.8381 57.4907L77.7882 51.8537L79.7451 40.5219L67.5 28.5137L84.3858 26.033L91.9902 10.5869L99.5387 26.033L108.597 27.3878L116.424 28.5137L104.179 40.5219Z",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3184 28.4264L84.111 27.0342C84.6879 26.966 85.1884 26.6 85.4306 26.0675L89.8392 16.3882L86.4884 26.7819C86.1778 27.7443 85.2895 28.3971 84.2856 28.3993L72.3184 28.4264Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18 40.5215L107.088 57.4904L91.992 49.4857L76.8398 57.4904L77.7899 51.8527C93.7249 46.4409 104.013 34.0388 108.598 27.3867L116.425 28.5126L104.18 40.5215Z",
    fill: "#F7B208"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0907 43.9586L66.971 54.2257L55.2628 52.6339L47.2808 61.3922L46.5744 57.5278L45.1856 49.748L34.3926 44.8964L44.8015 39.294L46.1219 27.5195L54.6655 35.7038L60.8798 34.4321L66.2399 33.3045L61.0907 43.9586Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.498 43.6992L44.8471 40.0057C45.2065 39.8253 45.4459 39.4703 45.4793 39.0687L46.0744 31.7749L46.3356 39.279C46.3596 39.9737 45.9347 40.6059 45.2815 40.8452L37.498 43.6992Z",
    fill: "#FFD800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0808 43.9578L66.9611 54.2241L55.2529 52.6331L47.2708 61.3914L46.5645 57.5262C55.6661 50.2571 59.4483 39.8118 60.8698 34.4313L66.23 33.3037L61.0808 43.9578Z",
    fill: "#F7B208"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7674 64.9693L33.805 72.605L22.2583 75.1141L17.7529 86.0745L15.7676 82.6844L11.8013 75.8489L0 74.981L7.86562 66.1572L5.07933 54.6411L15.9066 59.4098L21.3111 56.0888L25.9619 53.1963L24.7674 64.9693Z",
    fill: "#FFBF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51758 72.7911L8.16072 66.8075C8.43716 66.5143 8.54047 66.0989 8.43425 65.7112L6.49913 58.6538L9.31088 65.6166C9.57132 66.2612 9.38799 67.0003 8.8562 67.4492L2.51758 72.7911Z",
    fill: "#FFD800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7674 64.9688L33.8042 72.6052L22.2582 75.1143L17.7529 86.0747L15.7676 82.6846C21.8341 72.7405 21.8159 61.6325 21.3118 56.0898L25.9626 53.1973L24.7674 64.9688Z",
    fill: "#F7B208"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.912 43.9586L117.031 54.2257L128.739 52.6339L136.721 61.3922L137.428 57.5278L138.817 49.748L149.61 44.8964L139.201 39.294L137.88 27.5195L129.337 35.7038L123.123 34.4321L117.762 33.3045L122.912 43.9586Z",
    fill: "#D6D6D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.499 43.6989L139.15 40.0062C138.79 39.8258 138.551 39.4708 138.517 39.0692L137.922 31.7754L137.661 39.2794C137.637 39.9742 138.062 40.6064 138.715 40.8457L146.499 43.6989Z",
    fill: "#D6D6D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.917 43.9583L117.037 54.2246L128.745 52.6336L136.727 61.3919L137.434 57.5267C128.332 50.2576 124.55 39.8123 123.128 34.4318L117.768 33.3042L122.917 43.9583Z",
    fill: "#D6D6D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.236 64.9673L150.199 72.603L161.746 75.1121L166.251 86.0725L168.237 82.6824L172.203 75.8469L184.004 74.979L176.139 66.1553L178.925 54.6391L168.098 59.4078L162.693 56.0868L158.042 53.1943L159.236 64.9673Z",
    fill: "#FFBF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.483 72.7906L175.84 66.807C175.563 66.5138 175.46 66.0985 175.566 65.7107L177.501 58.6533L174.689 65.6161C174.429 66.2607 174.612 66.9998 175.144 67.4487L181.483 72.7906Z",
    fill: "#FFD800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.232 64.9688L150.195 72.6052L161.741 75.1143L166.247 86.0747L168.232 82.6846C162.165 72.7405 162.184 61.6325 162.688 56.0898L158.037 53.1973L159.232 64.9688Z",
    fill: "#F7B208"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.236 64.9673L150.199 72.603L161.746 75.1121L166.251 86.0725L168.237 82.6824L172.203 75.8469L184.004 74.979L176.139 66.1553L178.925 54.6391L168.098 59.4078L162.693 56.0868L158.042 53.1943L159.236 64.9673Z",
    fill: "#D6D6D6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M181.483 72.7906L175.84 66.807C175.563 66.5138 175.46 66.0985 175.566 65.7107L177.501 58.6533L174.689 65.6161C174.429 66.2607 174.612 66.9998 175.144 67.4487L181.483 72.7906Z",
    fill: "#D6D6D6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.232 64.9688L150.195 72.6052L161.741 75.1143L166.247 86.0747L168.232 82.6846C162.165 72.7405 162.184 61.6325 162.688 56.0898L158.037 53.1973L159.232 64.9688Z",
    fill: "#D6D6D6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5119 103.55V135.009C88.7485 136.609 96.0521 137.971 103.434 138.689C107.123 139.048 110.83 139.245 114.536 139.221C117.688 139.2 121.115 139.308 124.137 138.281C126.465 137.49 129.148 135.873 129.148 133.257C129.148 130.773 127.872 129.304 126.594 128.836C129.348 128.836 131.58 126.604 131.58 123.851C131.58 121.403 129.834 119.387 127.873 118.848C130.644 118.848 132.876 116.616 132.876 113.844C132.876 111.685 131.509 109.867 129.997 109.165C132.75 109.165 135 106.934 135 104.162C135 101.409 132.75 99.1768 129.997 99.1768H112.053C114.177 91.7618 113.439 85.9846 112.053 78.2461C110.668 70.5072 103.307 71.1554 102.587 74.6649C101.849 78.1744 103.648 81.1439 99.0413 89.9984C95.6396 96.5492 86.1009 101.48 81.5119 103.55Z",
    fill: "#F4C99A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3022 101.373H84.1738V137.799H61.3022V101.373Z",
    fill: "#EDF2EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1951 100.708H77.9238V138.224H50.1951V100.708Z",
    fill: "#2479F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0451 131.566C72.8713 131.566 73.6345 132.007 74.0478 132.722C74.4606 133.438 74.4606 134.319 74.0478 135.035C73.6349 135.75 72.8713 136.191 72.0451 136.191C71.2189 136.191 70.4557 135.75 70.0424 135.035C69.6295 134.319 69.6295 133.438 70.0424 132.722C70.4557 132.006 71.2189 131.566 72.0451 131.566Z",
    fill: "#EDF2EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating25);
export default __webpack_public_path__ + "static/media/Rating-2_5.4cbe31a139ed74e866febecb6f2feaad.svg";
export { ForwardRef as ReactComponent };